import { render, staticRenderFns } from "./MedicalReport.vue?vue&type=template&id=56607870"
import script from "./MedicalReport.vue?vue&type=script&lang=js"
export * from "./MedicalReport.vue?vue&type=script&lang=js"
import style0 from "./MedicalReport.vue?vue&type=style&index=0&id=56607870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports